/**
 * Per-photo re-attestation toggle for legacy photos on any item type's
 * edit modal. Shown in the photo card next to caption/credit/etc.
 *
 *   - If the photo is already attested → shows a subtle "✓ Rights attested"
 *     confirmation (immutable in the UI; unchecking would be a legally
 *     ambiguous action, so we don't allow it).
 *   - Otherwise → shows a checkbox the user can tick to opt this specific
 *     photo in to community discovery representation. The checkbox is
 *     write-once: once ticked, it becomes the "already attested" chip on
 *     re-render.
 *
 * Absent === grandfathered (visible in the user's own collection and in
 * the polish/community photo gallery, but never picked for tile-hero
 * representation across discovery surfaces).
 *
 * `label` lets callers tweak the discovery-context wording per item type
 * ("polish", "plate", "cuticle oil", etc.).
 */

interface Props {
  attested: boolean;
  onAttest: () => void;
  /** Item type noun for the discovery-context wording. */
  itemLabel?: string;
}

export default function PerPhotoReAttest({ attested, onAttest, itemLabel = 'item' }: Props) {
  if (!!attested) {
    return (
      <div className="flex items-center gap-1 text-[10px] text-emerald-700 mt-0.5">
        <span>✓ Rights attested</span>
      </div>
    );
  }
  return (
    <label className="flex items-start gap-1.5 text-[10px] text-gray-600 mt-0.5 cursor-pointer">
      <input
        type="checkbox"
        checked={false}
        onChange={(e) => {
          if (e.target.checked) onAttest();
        }}
        className="mt-0.5"
      />
      <span>
        I have the right to share this image (allows it to represent this {itemLabel} across discovery tiles)
      </span>
    </label>
  );
}
